import * as api from "api";
import ReactGA from "react-ga4";

// Get Pricing
export const getUnitPriceAsync = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Payments",
            action: "Get Unit Price",
        });
        dispatch(
            api.get({
                path: "payments/unitPrice",
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                    return [];
                },
            })
        );
    });
};

// Get My Org Balance
export const getMyOrgBalanceAsync = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Payments",
            action: "Get My Org Balance",
        });
        dispatch(
            api.get({
                path: `payments/balance`,
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                    return [];
                },
            })
        );
    });
};

export const getSavedCardsAsync = () => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Payments",
            action: "Get Saved Cards",
        });
        dispatch(
            api.get({
                path: `payments/savedcards`,
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    reject("An unexpected error has occured. Please try again or call support if the problem persists.");
                    return [];
                },
            })
        );
    });
};

export const setRecurringFarmSubscriptionsAsync = (farmIds, paymentTokenId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Payments",
            action: "Set Recurring",
        });
        dispatch(
            api.post({
                path: "payments/recurring",
                content: { farmIds, paymentTokenId },
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    let message = "An unexpected error has occured. Please try again or call support if the problem persists.";
                    if (error.status === 400 && error.response && error.response.length > 0) message = error.response[0].errorMessage;
                    reject({ status: error.status, message });
                    return [];
                },
            })
        );
    });
};

// Pay by Invoice
export const payByInvoiceAsync = (farmIds, reference) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Payments",
            action: "Pay by Invoice",
        });
        dispatch(
            api.post({
                path: "payments/invoice",
                content: { farmIds, reference },
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    let message = "An unexpected error has occured. Please try again or call support if the problem persists.";
                    if (error.status === 400 && error.response && error.response.length > 0) message = error.response[0].errorMessage;
                    reject({ status: error.status, message });
                    return [];
                },
            })
        );
    });
};

// Pay by Invoice
export const payByPaystationTokenAsync = (farmIds, reference, paymentTokenId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Payments",
            action: "Pay by Saved Card",
        });
        dispatch(
            api.post({
                path: "payments/payByPaystationToken",
                content: { farmIds, reference, paymentTokenId },
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    let message = "An unexpected error has occured. Please try again or call support if the problem persists.";
                    if (error.status === 400 && error.response && error.response.length > 0) message = error.response[0].errorMessage;
                    reject({ status: error.status, message });
                    return [];
                },
            })
        );
    });
};

// Pay by Paystation
export const payByPaystationCardAsync = (farmIds, reference, paymentMethod, saveCard) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Payments",
            action: "Pay by Paystation",
        });
        dispatch(
            api.post({
                path: "payments/payByPaystationCard",
                content: { farmIds, reference, saveCard, paymentMethod },
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    let message = "An unexpected error has occured. Please try again or call support if the problem persists.";
                    if (error.status === 400 && error.response && error.response.length > 0) message = error.response[0].errorMessage;
                    reject({ status: error.status, message });
                    return [];
                },
            })
        );
    });
};

export const sendPaymentAdvice = (paymentAdvice) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Payments",
            action: "Send payment request",
        });
        dispatch(
            api.post({
                path: "payments/paymentAdvice",
                content: paymentAdvice,
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    let message = "An unexpected error has occured. Please try again or call support if the problem persists.";
                    if (error.status === 400 && error.response && error.response.length > 0) message = error.response[0].errorMessage;
                    reject({ status: error.status, message });
                    return [];
                },
            })
        );
    });
};

// Get Payment State
export const getPaymentStateAsync = (paymentId) => (dispatch) => {
    return new Promise((resolve, reject) => {
        ReactGA.event({
            category: "Payments",
            action: "Get Payment State",
        });
        dispatch(
            api.get({
                path: `payments/${paymentId}/state`,
                onSuccess: (response) => {
                    resolve(response);
                    return [];
                },
                onFailure: (error) => {
                    error.handled = true;
                    let message = "An unexpected error has occured. Please try again or call support if the problem persists.";
                    if (error.status === 400 && error.response && error.response.length > 0) message = error.response[0].errorMessage;
                    reject({ status: error.status, message });
                    return [];
                },
            })
        );
    });
};
